import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export type AlertType = 'success' | 'warning' | 'danger' | 'info' | 'location';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './alert.component.html'
})
export class AlertComponent {
  @Input()
  public alertTitle: string = '';

  @Input()
  public content: string = '';

  @Input()
  public type: AlertType = 'info';

  @Input()
  public closable: boolean = true;

  @Input()
  withoutIcon: boolean = false;

  @Output()
  public onClose = new EventEmitter();
  protected readonly close = close;
}
